<div mat-dialog-title>
  <div class="heading">
    <h1 class="heading-item">{{ fileName }}</h1>
    @if (totalPages) {
    <p class="heading-item">{{ currentPage }} / {{ totalPages }}</p>
    }
    <div class="heading-item right">
      <button mat-icon-button (click)="downloadPdf()">
        <mat-icon>download</mat-icon>
      </button>
      <button mat-icon-button (click)="printPdf()">
        <mat-icon>print</mat-icon>
      </button>
    </div>
  </div>
</div>

<pdf-viewer
  [src]="pdfSrc"
  [show-all]="true"
  [render-text]="true"
  [original-size]="true"
  [fit-to-page]="true"
  [autoresize]="false"
  [show-borders]="true"
  [(page)]="currentPage"
  (after-load-complete)="afterLoadComplete($event)"
></pdf-viewer>

<div #actionsContainer mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button (click)="close()">{{ 'Close' | translate }}</button>
</div>

@if (isPrinting) {
<iframe #printf class="print-frame" [src]="srcUrl"></iframe>
}
